import { useEffect, useState } from "react";

export const EXERCISE_THUMBNAIL_PATH_PREFIX = "exercise-thumbnails/v1";

export function getExerciseThumbnailObjectKey(exerciseId) {
  if (!exerciseId) {
    return null;
  }
  return `${EXERCISE_THUMBNAIL_PATH_PREFIX}/${encodeURIComponent(exerciseId)}.webp`;
}

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function ExerciseThumbnail({
  exerciseId,
  src = null,
  size = 64,
  alt = "",
  loading = "lazy",
  decoding = "async",
  fetchPriority,
  className = "",
  onLoad,
  onError,
  ...props
}) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const dimension = Number.isFinite(size) ? size : 64;
  const state = !src ? "placeholder" : failed ? "error" : loaded ? "loaded" : "loading";

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
  }, [src]);

  return (
    <span
      {...props}
      className={joinClassNames("lz-v2-exercise-thumbnail", className)}
      data-testid="exercise-thumbnail"
      data-exercise-id={exerciseId || undefined}
      data-object-key={getExerciseThumbnailObjectKey(exerciseId) || undefined}
      data-state={state}
      style={{ width: dimension, height: dimension, ...props.style }}
    >
      <span className="lz-v2-exercise-thumbnail__placeholder" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M7 8v8M4 9.5v5M17 8v8M20 9.5v5M7 12h10" />
        </svg>
      </span>
      {src && !failed ? (
        <img
          className="lz-v2-exercise-thumbnail__image"
          src={src}
          alt={alt}
          width={dimension}
          height={dimension}
          loading={loading}
          decoding={decoding}
          fetchpriority={fetchPriority}
          data-loaded={loaded ? "true" : "false"}
          onLoad={(event) => {
            setLoaded(true);
            onLoad?.(event);
          }}
          onError={(event) => {
            setFailed(true);
            onError?.(event);
          }}
        />
      ) : null}
      {failed ? <span className="lz-v2-visually-hidden">Image unavailable</span> : null}
    </span>
  );
}
